export const select_options = {
  test_status: [
    {
      label: "Pending",
      value: "P",
    },
    {
      label: "Under Test",
      value: "U",
    },
    {
      label: "Completed",
      value: "D",
    },
    {
      label: "OOS",
      value: "OOS",
    },
    {
      label: "OOT",
      value: "OOT",
    },
    {
      label: "Deviation",
      value: "Deviation",
    },
    {
      label: "Lab Event",
      value: "Lab Event",
    },
    {
      label: "Not Required",
      value: "N",
    },
    {
      label: "Review Completed",
      value: "Review Completed",
    },
  ],
  reviewer_remark_status: [
    {
      label: "Pending",
      value: "Pending",
    },
    {
      label: "Completed",
      value: "Completed",
    },
    // {
    //   "label": "Review",
    //   "value": "Review"
    // },
    {
      label: "OOS",
      value: "OOS",
    },
    {
      label: "OOT",
      value: "OOT",
    },
    {
      label: "Deviation",
      value: "Deviation",
    },
    // {
    //   "label": "Investigation",
    //   "value": "Investigation"
    // },
    // {
    //   "label": "Terminated",
    //   "value": "Terminated"
    // },
    {
      label: "Lab Event",
      value: "Lab Event",
    },
    {
      label: "QMS Impacted sample",
      value: "QMS Impacted sample",
    },
  ],

  remark_status: [
    {
      label: "Pending",
      value: "Pending",
    },
    {
      label: "QC Testing Completed",
      value: "QC Testing Completed",
    },
    {
      label: "Under Review",
      value: "Under Review",
    },
    {
      label: "Awaiting Approval",
      value: "Awaiting Approval",
    },
    {
      label: "Under UD",
      value: "Under UD",
    },
    {
      label: "UD Approved",
      value: "UD Approved",
    },
    {
      label: "On Hold",
      value: "On Hold",
    },
    {
      label: "Conditional Release",
      value: "Conditional Release",
    },
    {
      label: "OOS",
      value: "OOS",
    },
    {
      label: "OOT",
      value: "OOT",
    },
    {
      label: "Deviation",
      value: "Deviation",
    },
    {
      label: "Lab Event",
      value: "Lab Event",
    },
  ],
};
